import { useTheme } from '@mui/material';
import { Check, X } from 'lucide-react';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomstructureset';

export default function StructureReviewStatus({
    status,
}: {
    status: DICOMApprovalStatus;
}) {
    const { palette } = useTheme();
    switch (status) {
        case DICOMApprovalStatus.APPROVED:
            return (
                <Check
                    style={{ marginRight: 8 }}
                    size="16px"
                    color={palette.success.main}
                />
            );
        case DICOMApprovalStatus.REJECTED:
            return (
                <X
                    style={{ marginRight: 8 }}
                    size="18px"
                    color={palette.error.main}
                />
            );
        default:
            return null;
    }
}
